import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { timKiemDSNhanVien } from "../../services/nhanvien";
import { NhanVienResponse, TimKiemNhanVienRequest } from "../../models/nhanvien/NhanVien";
import { NhanVienTheoLopDaoTao } from '../../models/daotao/LopDaoTao';
import { Col, Input, Row, Spin, Table } from 'antd';
import Column from 'antd/es/table/Column';
import { NhanVienTheoToBan } from '../../models/toban/ToBan';

const DanhSachNhanVienTheoDonViTableModal = ({ checklist, hide, onChange, idLopDaoTao }: { checklist: Array<NhanVienTheoLopDaoTao> | Array<NhanVienTheoToBan>, hide: () => void, onChange: (data: any, e: any) => void, idLopDaoTao: number }) => {
    const [data, setData] = useState<Array<NhanVienResponse>>([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev={undefined} />;
    const layDuLieu = async () => {
        try {
            setLoading(true);
            var rq = new TimKiemNhanVienRequest;
            rq.idDonVi = 1;
            rq.tuKhoa = "";
            let rs = await timKiemDSNhanVien(rq, 0, 0);
            setData(rs.data);
            setLoading(false);
        } catch (error: any) {
        };
    }

    useEffect(() => {
        layDuLieu();
    }, []);

    const dsDaChon = checklist.map(x => x.idNhanVien);
    const dsHienThi = data
        .map((item: any, index) => { item.key = index; return item; })
        .filter((record: NhanVienResponse) => record.hoTen.toLowerCase().includes(searchText.toLowerCase()));
    const soLuongDaChon = dsHienThi.filter((record: NhanVienResponse) => dsDaChon.includes(record.id)).length;
    const chonTatCa = dsHienThi.length > 0 && soLuongDaChon === dsHienThi.length;
    const chonMotPhan = soLuongDaChon > 0 && !chonTatCa;

    const taoDuLieuNhanVien = (value: NhanVienResponse) => ({
        "hoTen": value.hoTen,
        "tenDonVi": value.tenDonVi,
        "tenChucVu": value.tenChucVu,
        "diemDanhGia": "",
        "ketQuaDaoTao": "",
        "idNhanVien": value.id,
        "isCapChungChi": false,
        "idLopDaoTao": idLopDaoTao
    });

    const onChangeChonTatCa = (isChecked: boolean) => {
        dsHienThi.forEach((record: NhanVienResponse) => {
            var daChon = dsDaChon.includes(record.id);
            if (isChecked !== daChon) {
                onChange(taoDuLieuNhanVien(record), isChecked);
            }
        });
    };

    return (
        <section>
            <Modal show={true} onHide={hide} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Danh sách nhân viên</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ?
                        <div className='text-center'><Spin indicator={antIcon} /></div> :
                        <>
                            <Row className="form-group">
                                <Col span={12}>
                                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên nhân viên để tìm kiếm..." onChange={(e) => setSearchText(e.target.value)} />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Table
                                        locale={{ emptyText: "Không có dữ liệu" }}
                                        dataSource={dsHienThi}
                                        pagination={false}
                                    >
                                        <Column
                                            title="STT"
                                            key="STT"
                                            render={(value, record, index) =>
                                            (
                                                <>
                                                    {index + 1}
                                                </>
                                            )
                                            }
                                        />
                                        <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                        <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                                        <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                        <Column
                                            title={
                                                <div className='text-center'>
                                                    <input type="checkbox"
                                                        title="Chọn tất cả"
                                                        disabled={dsHienThi.length === 0}
                                                        checked={chonTatCa}
                                                        ref={(el) => { if (el) el.indeterminate = chonMotPhan; }}
                                                        onChange={(e) => onChangeChonTatCa(e.target.checked)}
                                                    />
                                                </div>
                                            }
                                            key="choose"
                                            render={(value: NhanVienResponse, record, index) =>
                                            (
                                                <div className='text-center' key={value.id}>
                                                    <input type="checkbox" title="Chọn"
                                                    data-index={value?.id}
                                                    checked={dsDaChon.includes(value?.id) ? true : false}
                                                    onChange={(e) => {
                                                        onChange(taoDuLieuNhanVien(value), e.target.checked)
                                                    }}
                                                />
                                                </div>
                                            )
                                            }
                                        />
                                    </Table>
                                </Col>
                            </Row>
                        </>
                    }
                </Modal.Body>
            </Modal >
        </section>
    );
};
export default DanhSachNhanVienTheoDonViTableModal;
